import { render, staticRenderFns } from "./ConfirmHandoffModal.vue?vue&type=template&id=138512d5&scoped=true"
import script from "./ConfirmHandoffModal.vue?vue&type=script&lang=js"
export * from "./ConfirmHandoffModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmHandoffModal.vue?vue&type=style&index=0&id=138512d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138512d5",
  null
  
)

export default component.exports